import type { ReactElement, ReactNode } from 'react';
import { Box, SurfaceHeader } from '@citibox-panel/ui';

export interface SpaceLayoutProps {
  brand: ReactNode;
  end: ReactNode;
  nav?: ReactNode;
  children: ReactNode;
}

// The chrome of every space but Soporte, whose search shell carries its own band.
export function SpaceLayout({ brand, end, nav, children }: SpaceLayoutProps): ReactElement {
  return (
    <>
      <SurfaceHeader brand={brand} end={end} />
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        {nav}
        <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
      </Box>
    </>
  );
}
